import React from 'react';
// Components
import StreamSalesReportTable from 'components/common/StreamSalesReportTable/StreamSalesReportTable';

const StreamSalesReport = (): JSX.Element => {
  return <StreamSalesReportTable />;
};

export default StreamSalesReport;
